import(/* webpackMode: "eager" */ "/tmp/8dee03d7c805bcf/app/[locale]/error.tsx");
